"use client";

import React from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { DesignersMenu, EventsMenu } from "@/components/layout/NavMenu";
import {
  designerLinks,
  hiringLinks,
  isCurrentPage,
} from "@/components/layout/navLinks";

interface HeaderNavigationProps {
  scrolled?: boolean;
}

/** Site-wide desktop nav: homepage sections, Events, then the designer menu. */
const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
  scrolled = false,
}) => {
  const pathname = usePathname();
  const onHome = pathname === "/";
  const inMenu = (links: typeof designerLinks) =>
    links.some((link) => isCurrentPage(pathname, link.href));

  const itemClass = (current: boolean) =>
    `px-3 py-1.5 text-sm font-medium text-black rounded-full transition-all whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2B1B1C] xl:px-4 ${
      current ? "bg-[#EDEAE7]" : "bg-transparent"
    }`;

  return (
    <nav aria-label="Main" className="relative hidden items-center xl:flex">
      <div
        className={`inline-flex h-10 items-center rounded-full px-1 transition-all duration-300 ${
          scrolled ? "bg-white" : "bg-white/60"
        }`}
      >
        {hiringLinks.map((link) =>
          // On the homepage, jump within the page; elsewhere, go to the homepage section.
          onHome ? (
            <a
              key={link.href}
              href={link.href.slice(1)}
              className={itemClass(false)}
            >
              {link.title}
            </a>
          ) : (
            <Link key={link.href} href={link.href} className={itemClass(false)}>
              {link.title}
            </Link>
          ),
        )}
        <EventsMenu
          current={pathname === "/events"}
          triggerClassName={itemClass(pathname === "/events")}
        />
        <DesignersMenu
          current={inMenu(designerLinks)}
          triggerClassName={itemClass(inMenu(designerLinks))}
        />
      </div>
    </nav>
  );
};

export default HeaderNavigation;
